import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {TfFormInputFieldComponent} from "./tf-form-input-field/tf-form-input-field.component";

@NgModule({
  declarations: [TfFormInputFieldComponent],
  imports: [
    CommonModule
  ],
  exports: [TfFormInputFieldComponent]
})
export class TfInputFieldsModule { }
